import React, { Fragment, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import routes from './routes/routes'
import DashboardMaster from './components/layouts/DashboardMaster'

// Context:States
import UserState from './context/user/userState'

// Pages | Routes
const Home = React.lazy(() => import('./pages/Home'));
const Components = React.lazy(() => import('./pages/Renderer'))
const About: any = React.lazy(() => import('./pages/About'))
const Contact: any = React.lazy(() => import('./pages/Contact'))
const UpdatesPage: any = React.lazy(() => import('./pages/Updates'))
const NotFoundPage = React.lazy(() => import('./pages/404'));
const Dashboard = React.lazy(() => import('./pages/dashboard/Dashboard'));
const AccountProfile = React.lazy(() => import('./pages/dashboard/account/Profile'));
const AccountBilling = React.lazy(() => import('./pages/dashboard/account/Billing'));
const AccountPreferences = React.lazy(() => import('./pages/dashboard/account/Preferences'));


const App = () => {

    const errorHandler = (err: any, info: any) => {
        console.log(err, 'logged error');
        console.log(info, 'logged error info');
    }

    const getAppPages = (name: string) => {

        switch (name) {
            case 'components':
                return <Components />
            case '/':
                return <Home />
            case 'home':
                return <Home />
            case 'not-found':
                return <NotFoundPage />
            case 'about':
                return <About />
            case 'contact':
                return <Contact />
            case 'updates':
                return <UpdatesPage />
            case 'dashboard':
                return <Dashboard />
            case 'account-profile':
                return <AccountProfile />
            case 'account-billing':
                return <AccountBilling />
            case 'account-preferences':
                return <AccountPreferences />
            default:
                return <NotFoundPage />
        }

    }

    return (

        <Router>

            <UserState>

                <Suspense fallback={(<></>)}>

                    <ErrorBoundary FallbackComponent={() => (<></>)} onReset={() => { window.location.reload() }} onError={errorHandler}>

                        <Routes>

                            {
                                routes.map((route, index) =>
                                    <Fragment key={`route-${index + 1}`}>

                                        {
                                            !route.isAuth &&
                                            <Route
                                                path={route.url}
                                                element={getAppPages(route.name)}
                                            />
                                        }

                                        {
                                            route.isAuth && route.name !== 'divider' &&
                                            <>
                                                <Route
                                                    path={route.url}
                                                    element={
                                                        <DashboardMaster
                                                            component={getAppPages(route.name)}
                                                            title={route.title ? route.title : route.name}
                                                            back={true}
                                                            sidebar={{
                                                                collapsed: route.content.sidebar !== undefined ? route.content.sidebar : false
                                                            }}
                                                        />
                                                    }
                                                />

                                                {
                                                    route.subroutes && route.subroutes.length > 0 &&
                                                    route.subroutes.map((subroute, index) =>
                                                        <Fragment key={`${subroute.name}-route-${index + 1}`}>

                                                            <Route
                                                                path={route.url + subroute.url}
                                                                element={
                                                                    <DashboardMaster
                                                                        component={getAppPages(`${route.name}-${subroute.name}`)}
                                                                        title={subroute.title ? subroute.title : subroute.name}
                                                                        back={true}
                                                                        sidebar={{
                                                                            collapsed: subroute.content.sidebar !== undefined ? subroute.content.sidebar : false
                                                                        }}
                                                                    />
                                                                }
                                                            />

                                                        </Fragment>
                                                    )
                                                }
                                            </>
                                        }

                                    </Fragment>
                                )
                            }

                        </Routes>

                    </ErrorBoundary>

                </Suspense>

            </UserState>

        </Router>

    )

}

export default App;